import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RateReviewRoundedIcon from '@mui/icons-material/RateReviewRounded';
import { Theme } from '@mui/material/styles';
import React from 'react';

import { AnnotationWorkingStates } from 'interfaces/annotation';

export const AnnotationWorkingStatesIcons = {
  [AnnotationWorkingStates.Annotating]: <EditOutlinedIcon />,
  [AnnotationWorkingStates.QA]: <RateReviewRoundedIcon />,
  [AnnotationWorkingStates.Done]: <CheckCircleRoundedIcon />,
};

export const AnnotationWorkingStateLabels: Record<AnnotationWorkingStates, string> = {
  [AnnotationWorkingStates.Annotating]: 'Annotating',
  [AnnotationWorkingStates.QA]: 'QA',
  [AnnotationWorkingStates.Done]: 'Done',
};

export const getAnnotationWorkingStateLabel = (state: AnnotationWorkingStates) =>
  AnnotationWorkingStateLabels[state] ?? state;

export const getAnnotationWorkingStateColor = (theme: Theme, state: AnnotationWorkingStates): string => {
  const colorByState: Record<AnnotationWorkingStates, string> = {
    [AnnotationWorkingStates.Annotating]: theme.palette.primary.main,
    [AnnotationWorkingStates.QA]: theme.palette.secondary.main,
    [AnnotationWorkingStates.Done]: theme.palette.success.main,
  };

  return colorByState[state] ?? theme.palette.text.secondary;
};

export interface WorkingStateTransitionCopy {
  title: string;
  text: string;
  confirmButtonTitle: string;
  tooltipTitle: string;
}

// Single source of truth for "move to this state" wording, shared by every surface that lets a
// user change an assignment's working state (SlideStatusMenu's stepper, AnnotationStatusControl).
const workingStateTransitionCopy: Record<AnnotationWorkingStates, WorkingStateTransitionCopy> = {
  [AnnotationWorkingStates.Annotating]: {
    title: 'Reopen annotations for editing?',
    text: 'Reopen the current annotations so they can be updated?',
    confirmButtonTitle: 'Reopen',
    tooltipTitle: 'Reopen for editing',
  },
  [AnnotationWorkingStates.QA]: {
    title: 'Ready for review?',
    text: 'Are the current annotations ready for review (QA)?',
    confirmButtonTitle: 'Send to QA',
    tooltipTitle: 'Send to QA review',
  },
  [AnnotationWorkingStates.Done]: {
    title: 'Mark annotations done?',
    text: 'Are the current annotations complete?',
    confirmButtonTitle: 'Mark done',
    tooltipTitle: 'Mark done',
  },
};

export const getWorkingStateTransitionCopy = (state: AnnotationWorkingStates): WorkingStateTransitionCopy =>
  workingStateTransitionCopy[state];
